export const join = (...args: string[]) => args.join('/');
export const dirname = (p: string) => p.split('/').slice(0, -1).join('/');
export const resolve = (...args: string[]) => args.join('/');
export const basename = (p: string) => p.split('/').pop() || '';
export default { join, dirname, resolve, basename };
